var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
export default /*#__PURE__*/React.memo(function SvgOsBsd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    role: "presentation",
    "data-ignore-dark-theme-adapter": true
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.717 3.032c-.057.19-.16.253-.376.218-.547-.086-.96.264-.936.82.012.302.087.622.217.895.532 1.104 1.328 1.944 2.544 2.284.76.213 1.242-.235 1.14-1.016-.03-.227-.03-.227.287-.441.985 1.688.9 4.615-1.13 6.575-2.156 2.083-5.473 2.184-7.799.244-2.205-1.84-2.643-5.14-.996-7.567 1.655-2.435 4.804-3.07 7.05-2.012Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.652 2.258c.643.005.866.259.79.758a2.2 2.2 0 0 1-.117.462c-.416 1.049-1.017 1.97-1.881 2.71-.142.122-.256.135-.423.057-.797-.37-1.326-.976-1.602-1.801a.37.37 0 0 1 .068-.317c.7-.712 1.49-1.302 2.428-1.667.276-.108.576-.16.738-.202ZM2.98 4.852c-.463-.54-.842-1.075-.955-1.747-.141-.837.326-1.257 1.157-1.055.587.143 1.085.455 1.571.85A6 6 0 0 0 2.98 4.852",
    clipRule: "evenodd"
  })));
});